import { ContainerModule } from 'inversify';
import questionStoreModule, { QuestionStoreModuleSymbol } from './question-store-module'
import { LoadQuestionsJob } from './load-questions-job';

export const questionStateModule = new ContainerModule((bind) => {
  bind(QuestionStoreModuleSymbol).toConstantValue(questionStoreModule);
  bind(LoadQuestionsJob).toSelf();
})
